import request from '../request'

//导航
//https://restapi.amap.com/v5/direction/driving?parameters
export function get_driving(params) {
    return request({
        //url: `https://restapi.amap.com/v5/direction/driving`, //驾车
        url:`https://restapi.amap.com/v5/direction/walking`,
        method: 'get',
        params: params
    })
}

//地理编码
//https://restapi.amap.com/v3/geocode/geo?address=北京市朝阳区阜通东大街6号&output=XML&key=<用户的key>
export function get_address(params) {
    return request({
        url: `https://restapi.amap.com/v3/geocode/geo`,
        method: 'get',
        params: params
    })
}